module.exports = __webpack_public_path__ + "img/img18.ceba9f8c.png";